export default __webpack_public_path__ + "static/media/FB486CE5-9227-45DD-926D-C2F1E110F25B_1_102_o.03ebafd0.jpeg";